var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showWalletConnectMessageBox
    ? _c(
        "div",
        { staticClass: "message-box-bg flex-center" },
        [
          _c("div", { staticClass: "message-box" }, [
            _c("div", { staticClass: "message-box-gradient" }),
            _c("div", { staticClass: "message-box-main" }, [
              _c("div", { staticClass: "message-box-top" }, [
                _c("h4", { staticClass: "flex-center" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("home.walletConnect.messageBox.title")) +
                      " "
                  ),
                ]),
                _c("i", {
                  staticClass: "icon icon-close",
                  on: { click: _vm.onShowMessageBox },
                }),
              ]),
              _c("div", { staticClass: "message-box-content" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "fxloading",
                        rawName: "v-fxloading",
                        value: _vm.isQrImgLoading,
                        expression: "isQrImgLoading",
                      },
                    ],
                    staticClass: "qr-img",
                  },
                  [_c("img", { attrs: { src: _vm.qrImg, alt: "" } })]
                ),
                _c(
                  "div",
                  {
                    staticClass: "but-refresh flex-center",
                    on: { click: _vm.refresh },
                  },
                  [
                    _c("i", { staticClass: "icon icon-refresh" }),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("common.walletConnectMessageBox.refresh"))
                      ),
                    ]),
                  ]
                ),
                _c("p", { staticClass: "describe" }, [
                  _vm._v(_vm._s(_vm.$t("home.walletConnect.messageBox.text"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "box-but" },
                [
                  _c(
                    "ButtonCommon",
                    {
                      attrs: { type: "blueGradient", width: "100%" },
                      on: {
                        click: function ($event) {
                          _vm.showDownloadFxWalletMessageBox = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon icon-down-2x" }),
                      _c("strong", { staticClass: "text-download" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.walletConnectMessageBox.getFxWallet")
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "message-box-bott" },
              [
                _vm.inviteAddress
                  ? [
                      _c("p", { staticClass: "message-box-bott-addr" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$format.captureAddress(_vm.inviteAddress)
                            )
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "common.walletConnectMessageBox.invitesText"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("p", { staticClass: "text-min text-opacity" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "common.walletConnectMessageBox.onceConnectedText"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  : [
                      _c("p", { staticClass: "message-box-bott-addr" }, [
                        _c(
                          "a",
                          {
                            staticClass: "a-link",
                            attrs: {
                              target: "_blank",
                              rel: "noopener noreferrer",
                              href: _vm.aLink,
                            },
                          },
                          [_vm._v(_vm._s(_vm.aLink))]
                        ),
                      ]),
                      _c("p", { staticClass: "text-min text-opacity" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "common.walletConnectMessageBox.inviteFriendsText"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _c("DownloadFxWallet", {
            attrs: { showMessageBox: _vm.showDownloadFxWalletMessageBox },
            on: {
              "update:showMessageBox": function ($event) {
                _vm.showDownloadFxWalletMessageBox = $event
              },
              "update:show-message-box": function ($event) {
                _vm.showDownloadFxWalletMessageBox = $event
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }